import ReactDOM from 'react-dom/client';

import 'leaflet/dist/leaflet.css';
import 'react-day-picker/style.css';
import './index.css';

import msalInstance from 'utils/msalInstance';
import App from 'App';

window.addEventListener('vite:preloadError', () => {
  window.location.reload(); // for example, refresh the page
});

void (async () => {
  await msalInstance.initialize();

  ReactDOM.createRoot(document.getElementById('root')!).render(<App msalInstance={msalInstance} />);
})();
